import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import FilterComponent from '../../components/common/FilterComponent';
import { getPricingFilters } from '../../queries/ScenarioForecast';
import useFilter from '../../hooks/useFilter';
import FilterComponentCreator from '../../components/common/FilterComponent/FilterComponentCreator';
import { PricingFilterConfig } from './PricingFilterConfig';

type Props = {
    handlePricingFilterValueChange: Dispatch<SetStateAction<any>>;
    setLoading: Dispatch<SetStateAction<number>>;
    pricingSelectedFilterValues: any
}

const PricingFilter = ({ handlePricingFilterValueChange, setLoading, pricingSelectedFilterValues }: Props) => {


    const [filterResponse, setFilterResponse] = useState<any>({});
    const { selectedFilter } = useFilter();
    useEffect(() => {
        (async () => {
            const data: any = await getFilters(pricingSelectedFilterValues)
            if (!data) return
            if (selectedFilter == "electrical" && data?.project_flag?.[0]?.project_flag)
                handleFilterValueChange("projectFlag", [data?.project_flag?.[0]?.project_flag])
            if (selectedFilter == "plumbing" && data?.pc?.[0]?.pc)
                handleFilterValueChange("pc", data?.pc?.[0]?.pc)
        })()
    }, []);

    const getFilters = async (pricingFilterValues: any) => {
        try {
            setLoading((prev) => prev + 1)
            const response = await getPricingFilters(pricingFilterValues, selectedFilter);
            setFilterResponse(response.data)
            return response.data;
        }
        catch (err) {
            console.log("Error fetching Summary filters:", err)
        }
        finally {
            setLoading((prev) => prev - 1)
        }
    }

    const handleFilterValueChange = (key: string, value: string | string[]) => {
        handlePricingFilterValueChange((prev: any) => ({ ...prev, [key]: value }))
        if (selectedFilter != "plumbing")
            getFilters({ ...pricingSelectedFilterValues, [key]: value })
    }
    return (
        <FilterComponentCreator config={PricingFilterConfig[selectedFilter]} data={filterResponse}
            handleFilterValueChange={handleFilterValueChange} values={pricingSelectedFilterValues} />
    )
}

export default PricingFilter